import { assetImages } from "constants";
import * as url from "helper/UrlHelper";

const JobFeedbackLeftPanel = ({ cqResponseData }) => {
  
  const jobData = cqResponseData.challengeid
    ? `${cqResponseData?.challengeid?.name} ${cqResponseData?.challengeid?.jobcode}`
    : "";

  const imageUrl = cqResponseData.profilepicture
    ? cqResponseData.profilepicture === ""
      ? assetImages.defaultUser
      : url.SERVER_URL + cqResponseData.profilepicture
    : assetImages.defaultUser;

  return (
    <div className="left_survey left_cv_info">
      <div className="cv_topbx p-3 body-bg">
        <div className="cv_top_info px-0 py-2 mb-3">
          <h3 className="text-primary fw-semibold mb-0 fs-md">{jobData}</h3>
        </div>
        <div className="profile_wrap">
          <h5 className="text-black fw-semibold mb-3">Capital Quest</h5>
          <div className="cv_profile_row d-flex gap-2">
            <div className="cv_pic overflow-hidden rounded-circle">
              <img
                src={imageUrl}
                className="h-100 w-100 object-fit-cover"
                alt=""
              />
            </div>
            <div className="survey_info">
              <h3 className="fs-md text-black mb-1">
                <strong>{cqResponseData.startupname.toUpperCase()}</strong>
              </h3>
              
            </div>
          </div>
        </div>
      </div>

      <div className="cv_bttmbx p-4 bg-primary">
        <div className="cv_innr">

          <div className="cv_info_row d-flex gap-3 mb-4">

            <div className="card-body text-white">
              {cqResponseData.founder && cqResponseData.founder.length > 0 ? (
                cqResponseData.founder.map((founder, index) => (
                  <div key={index} className="p-3 mb-3 border rounded">
                   
                    <div className="row">
                      <div className="col-md-6">
                        <p><strong>Name:</strong> <span className="text-danger">*</span> {founder.name || "Not provided"}</p>
                        <p><strong>Role:</strong> <span className="text-danger">*</span> {founder.role || "Not provided"}</p>
                        <p><strong>LinkedIn:</strong> {founder.linkedin || "N/A"}</p>
                        <p><strong>Equity Holding:</strong> {founder.equityholding || "N/A"}</p>
                      </div>
                      <div className="col-md-6">
                        <p><strong>Experience:</strong> {founder.experience || "N/A"}</p>
                        <p><strong>Skills:</strong> {founder.skills || "N/A"}</p>
                        <p><strong>About:</strong> {founder.about ? founder.about.substring(0, 70) + '...' : "N/A"}</p>
                        <p><strong>Notable Advisors:</strong> {founder.notableadvisors || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="alert alert-warning">
                  <p className="mb-0">No founding team members added. At least one founder is required.</p>
                </div>
              )}
            </div>
          
          </div>
          <div className="cv_info_row gap-3 mb-4 text-white">
           
            <p><strong>Funding Amount:</strong> {cqResponseData.fundingamount || "Not provided"}</p>
            <p><strong>Proposed Value:</strong> {cqResponseData.proposedvalue || "N/A"}</p>
            <p><strong>Funding Use:</strong> {cqResponseData.fundinguse || "N/A"}</p>
          </div>


         
        </div>
      </div>
    </div>


  );
};

export default JobFeedbackLeftPanel;
